import { SHStack, SHTypography } from "@components/design-systems";
import { MAAnalysisDataDTO } from "@models/managed-accounts/entities/step/fee";
import { AnalysisDataDTO } from "@models/platform-analysis/entities/steps/feature";
import { isNil } from "lodash";
import { memo } from "react";
import { BooleanCell } from "../boolean-cell";

type Props = {
  analysisData?: AnalysisDataDTO | MAAnalysisDataDTO;
};
export const ShortTextCell = memo(({ analysisData }: Props) => {
  const isPositiveScore =
    analysisData && analysisData && "isPositiveScore" in analysisData
      ? analysisData?.isPositiveScore
      : undefined;
  return (
    <SHStack gap={"5px"} alignItems={"center"} direction={"row"}>
      <SHTypography
        variant="body3"
        zIndex="1"
        colorVariant="third"
        textAlign="left"
        lineHeight={1.2}
      >
        {analysisData?.value}
      </SHTypography>
      {!isNil(isPositiveScore) && <BooleanCell value={isPositiveScore} />}
    </SHStack>
  );
});
